import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';

import ArrowForCheckbox from 'shared/ui/icons/ArrowForCheckbox';

import {isTranslate} from 'shared/lib/lang';

import {TariffCondition} from '../../model/useCheapestTariffWithBooleanLimit';

import HintPremium from '../HintPremium/HintPremium';

import styles from './CollapsiblePanel.module.scss';

interface CollapsiblePanelProps {
    title: string;
    children: React.ReactNode;
    defaultExpanded?: boolean;
    className?: string;
    textStyle?: string;
    isFreeTariff?: boolean | null;
    premiumCondition?: TariffCondition;
}

const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
    title,
    children,
    defaultExpanded = false,
    className = '',
    textStyle,
    isFreeTariff = false,
    premiumCondition = 'monitor_extended_methods',
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <div className={cn(styles.panel, className)}>
            <div
                className={styles.header}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <span className={cn(styles.title, textStyle)}>
                    {isFreeTariff && !isTranslate() && <HintPremium condition={premiumCondition} />}
                    {title}
                </span>
                <div className={cn(styles.arrow, !isExpanded && styles.expanded)}>
                    <ArrowForCheckbox />
                </div>
            </div>

            <CSSTransition
                in={isExpanded}
                timeout={200}
                classNames={{
                    enter: styles.contentEnter,
                    enterActive: styles.contentEnterActive,
                    exit: styles.contentExit,
                    exitActive: styles.contentExitActive,
                }}
                unmountOnExit
            >
                <div className={styles.content}>
                    {children}
                </div>
            </CSSTransition>
        </div>
    );
};

export default CollapsiblePanel;